import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIDashboard from "./soft-ui-dashboard";
import ToastPlugin from "./plugins/toast";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(SoftUIDashboard);
appInstance.use(ToastPlugin);

// Global SweetAlert2 configuration with z-index
const SwalWithConfig = Swal.mixin({
  customClass: {
    container: "swal-z-index-fix",
  },
});

appInstance.config.globalProperties.$swal = SwalWithConfig;

// Add global style for SweetAlert z-index
const style = document.createElement("style");
style.textContent = `
  .swal-z-index-fix {
    z-index: 200000 !important;
  }
  .swal2-container {
    z-index: 200000 !important;
  }
  /* Raise Bootstrap modals above the sidenav (z-index: 9999) */
  .modal-backdrop {
    z-index: 10050 !important;
  }
  .modal {
    z-index: 10055 !important;
  }
`;
document.head.appendChild(style);

appInstance.mount("#app");
